/**
 * Shared taxonomy for construction file categories.
 *
 * Both the per-project Files tab (`CopConstructionTrackingDetail`) and
 * the cross-project browser (`CopFilesConstruction`) render the same
 * left rail + category chips, so keeping the definitions in one place
 * prevents drift when we add/rename categories later.
 */
import {
  ScrollText,
  Palette,
  Wrench,
  Map as MapIcon,
  Camera,
  Folder,
} from "lucide-react";

export const FILE_CATEGORIES = [
  { key: "contract",   label: "Sözleşme",    Icon: ScrollText, tint: "bg-emerald-50 text-emerald-700", ring: "ring-emerald-200" },
  { key: "design",     label: "Tasarım",     Icon: Palette,    tint: "bg-violet-50 text-violet-700",   ring: "ring-violet-200" },
  { key: "production", label: "Üretim",      Icon: Wrench,     tint: "bg-amber-50 text-amber-700",     ring: "ring-amber-200" },
  { key: "site_plan",  label: "Alan Planı",  Icon: MapIcon,    tint: "bg-sky-50 text-sky-700",         ring: "ring-sky-200" },
  { key: "photos",     label: "Fotoğraflar", Icon: Camera,     tint: "bg-rose-50 text-rose-700",       ring: "ring-rose-200" },
  { key: "other",      label: "Diğer",       Icon: Folder,     tint: "bg-zinc-100 text-zinc-700",      ring: "ring-zinc-200" },
];

export const CATEGORY_META = Object.fromEntries(
  FILE_CATEGORIES.map((c) => [c.key, c])
);

// Legacy category values still stored on older records → user-facing bucket.
export const LEGACY_BUCKET = {
  site: "photos",
  delivery: "photos",
};

export function bucketOf(rawCategory) {
  const key = LEGACY_BUCKET[rawCategory] || rawCategory || "other";
  return CATEGORY_META[key] ? key : "other";
}

export function humanFileSize(bytes) {
  if (!bytes) return "—";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) return `${mb.toFixed(1)} MB`;
  const kb = bytes / 1024;
  if (kb >= 10) return `${kb.toFixed(0)} KB`;
  if (kb >= 1) return `${kb.toFixed(1)} KB`;
  return `${bytes} B`;
}
